import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    SEO_TITLE: 'Requests | Attendance | Crehana',
    SEO_DESCRIPTION:
      "Review and respond to your collaborators' overtime and compensation time requests.",

    BREADCRUMB_HOME: 'Home',
    BREADCRUMB_ATTENDANCE: 'Attendance',
    BREADCRUMB_REQUESTS: 'Requests',

    PAGE_TITLE: 'Requests',
    PAGE_DESCRIPTION:
      "Review and respond to your collaborators' overtime and compensation time requests.",

    TABLE_COLUMN_DATE: 'Date',
    TABLE_COLUMN_USER: 'User',
    TABLE_COLUMN_SHIFT: 'Shift',
    TABLE_COLUMN_OVERTIME: 'Overtime',
    TABLE_COLUMN_COMPENSATION: 'Compensation time',
    TABLE_COLUMN_REASON: 'Reason',
    TABLE_COLUMN_STATUS: 'Status',

    REQUEST_STATUS_PENDING: 'Pending',
    REQUEST_STATUS_APPROVED: 'Approved',
    REQUEST_STATUS_DENIED: 'Denied',
    REQUEST_STATUS_UPDATED_TOOLTIP:
      'The final time may differ from what was requested, since it reflects the time actually recorded during the workday and any adjustments made by the admin.',

    REQUESTS_ACTION_VIEW_DETAIL: 'View detail',
    REQUESTS_ACTION_RESPOND: 'Respond to request',

    REQUESTS_EMPTY_TITLE: 'No requests yet',
    REQUESTS_EMPTY_DESCRIPTION:
      "Your team's overtime and compensation time requests will show up here.",
    REQUESTS_NO_RESULTS_TITLE: 'No results to show',
    REQUESTS_NO_RESULTS_DESCRIPTION: 'Try again with a different filter.',

    FILTER_BUTTON_LABEL: 'Filter by',
    FILTER_ALL: 'All',
    FILTER_PANEL_LEGAL_ENTITY_LABEL: 'Legal Entity',
    FILTER_PANEL_GROUP_LABEL: 'Groups',
    FILTER_PANEL_POSITION_LABEL: 'Position',
    FILTER_PANEL_SHIFT_LABEL: 'Shift',
    FILTER_PANEL_LOCATION_LABEL: 'Clock-in location',
    FILTER_PANEL_DEVICE_LABEL: 'Devices',
    FILTER_PANEL_CLEAR: 'Clear',
    FILTER_DATE_FROM_LABEL: 'From',
    FILTER_DATE_TO_LABEL: 'To',
    FILTER_DATE_PLACEHOLDER: 'mm/dd/yyyy',

    ACTIONS_MENU_LABEL: 'More options',
    ACTIONS_MENU_CANCEL: 'Cancel',

    ERROR_TITLE: 'Something went wrong',
    ERROR_DESCRIPTION: "We couldn't load the requests. Please try again.",
    BUTTON_RETRY: 'Retry',

    // TIM-562 — "Respond to request" dialog
    RESPOND_DIALOG_TITLE: 'Respond to request',
    RESPOND_DIALOG_PROMPT: 'Choose how you want to respond to the request:',
    RESPOND_DIALOG_APPROVE: 'Approve',
    RESPOND_DIALOG_DENY: 'Deny',
    RESPOND_DIALOG_SURPLUS_AVAILABLE_LABEL: 'Available surplus time',
    RESPOND_DIALOG_SURPLUS_UNAVAILABLE: 'Not available yet',
    RESPOND_DIALOG_REQUESTED_OVERTIME_LABEL: 'Requested overtime',
    RESPOND_DIALOG_REQUESTED_COMPENSATION_LABEL: 'Requested compensation time',
    RESPOND_DIALOG_REASON_LABEL: 'Response reason',
    RESPOND_DIALOG_REASON_PLACEHOLDER: 'Enter the reason for your response',
    RESPOND_DIALOG_NO_SHIFT_BLOCK:
      'Before you approve this request, assign a shift to {{name}} for {{date}}.',
    RESPOND_DIALOG_NO_SHIFT_DATE_PATTERN: 'MMMM d, yyyy',
    RESPOND_DIALOG_CONFIRM_APPROVE: 'Confirm approval',
    RESPOND_DIALOG_CONFIRM_DENY: 'Confirm denial',
    VALIDATION_REASON_REQUIRED: 'Required field.',
    VALIDATION_REASON_TOO_LONG: 'Maximum {{max}} characters.',
    TOAST_REQUEST_APPROVED: 'The request was approved.',
    TOAST_REQUEST_DENIED: 'The request was denied.',
    TOAST_REQUEST_CONFLICT:
      'This request cannot be answered — it looks like someone else already resolved it.',
    TOAST_RESPOND_ERROR: "We couldn't process your request. Try again.",
  },
};
